import MarketPL from "./MarketPL";

export default MarketPL;